import * as React from "react";

class ButtonJText extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <svg
        className="buttonJ-text"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 214.06 82.57"
      >
        <g>
          <path
            fill="#fbf9ed"
            d="M91.62,39.77A16.48,16.48,0,0,1,88,45.1,20.15,20.15,0,0,0,96.28,48a10.09,10.09,0,0,0-1.64,2.43,20.53,20.53,0,0,1-8.71-3.56,25.23,25.23,0,0,1-8.68,3.67,15.9,15.9,0,0,0-1.63-2.4,22.79,22.79,0,0,0,8.31-3.09,18.28,18.28,0,0,1-3.32-5.22L83,39.09A13,13,0,0,0,86,43.45a11.77,11.77,0,0,0,3-4.47ZM84,36.07a24.08,24.08,0,0,1-6,5.29,20,20,0,0,0-2.13-2,18.19,18.19,0,0,0,5.54-4.31Zm11.92-1.2H76V32.23h8.85A18.38,18.38,0,0,0,83.65,30l2.59-.9a17.43,17.43,0,0,1,1.66,3.13l-.07,0h8Zm-5.65.06a35.87,35.87,0,0,1,5.83,4.79l-2.31,1.75a35.42,35.42,0,0,0-5.66-5Z"
          />
          <path
            fill="#fbf9ed"
            d="M117.9,40.7v9.85h-3.05V49.33H99.26V40.72h3v5.93h4.77V39.52h-6.61V31.28h2.86v5.63h3.75V29.37h3v7.54H114V31.28h3v8.24h-6.91v7.13h4.79V40.7Z"
          />
          <path
            fill="#fbf9ed"
            d="M120.56,39.77a26.36,26.36,0,0,0,1.11-5.93l2,.28a31.73,31.73,0,0,1-1,6.38Zm20.73-6.4v17h-2.77v-.89h-6.43v1.07h-2.63V37.5l-2,.93a20.77,20.77,0,0,0-1.12-3.56V50.58h-2.61V29.37h2.61v4.36l1.52-.61a28.31,28.31,0,0,1,1.62,4.29v-4h3.86a35.65,35.65,0,0,0,.68-3.93l3.18.32c-.34,1.25-.73,2.5-1.09,3.61ZM132.09,36v4.11h6.43V36Zm6.43,10.94V42.56h-6.43V46.9Z"
          />
          <path
            fill="#fbf9ed"
            d="M143.26,39.77a25.8,25.8,0,0,0,1.12-5.93l2,.28a31.73,31.73,0,0,1-1,6.38ZM164,33.37v17h-2.77v-.89H154.8v1.07h-2.63V37.5l-2,.93A19.8,19.8,0,0,0,149,34.87V50.58h-2.61V29.37H149v4.36l1.52-.61a28.31,28.31,0,0,1,1.62,4.29v-4H156a33.54,33.54,0,0,0,.69-3.93l3.17.32c-.34,1.25-.72,2.5-1.08,3.61ZM154.8,36v4.11h6.42V36Zm6.42,10.94V42.56H154.8V46.9Z"
          />
        </g>
      </svg>
    );
  }
}

export default ButtonJText;



// WEBPACK FOOTER //
// ./src/ending/components/ButtonJText.tsx